<div class="review-status-toggle-box">
  <cars-review-status-toggle [userReviewState]="userReviewState"></cars-review-status-toggle>
</div>
